import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../button'
import { useHistory } from 'react-router-dom'
import { createAppQuery } from '../../queries'
import { CreateApp } from '../../queries/types/CreateApp'
import { useMutation } from '@apollo/client'
import { Field, FormCard, PageHeader, inputClassName } from '../ui'

export function AppCreate(): JSX.Element {
    const {t} = useTranslation()
    const history = useHistory()
    const [name, setName] = useState('')
    const [s2sUrl, setS2SUrl] = useState('')
    const [ createApp ] = useMutation<CreateApp>(createAppQuery)

    function createAndGo() {
        createApp({
            variables: {
                name: name,
                s2sUrl: s2sUrl
            }
        }).then(() => {
            history.push('/apps')
        })
    }

    return (
        <>
            <PageHeader title={t('apps-create.title')} />
            <FormCard>
                <Field label={t('apps-create.form.label.name')}>
                    <input name='name' value={name} onChange={(e) => setName(e.target.value)} className={inputClassName} placeholder={t('apps-create.form.placeholder.name')} />
                </Field>
                <Field label={t('apps-create.form.label.s2s')}>
                    <input name='s2s' value={s2sUrl} onChange={(e) => setS2SUrl(e.target.value)} className={inputClassName} placeholder='https://' />
                </Field>
                <div className='mt-6 flex justify-end'>
                    <PrimaryButton onClick={() => createAndGo()} type='submit'>{t('shared.button.label.submit')}</PrimaryButton>
                </div>
            </FormCard>
        </>)
}
